import { Component, Input, OnDestroy } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  standalone: false,
})
export class NavbarComponent implements OnDestroy {
  @Input() logoClickable = true;

  menuOpen = false;
  swapActive = false;
  private menuTimer?: ReturnType<typeof setTimeout>;

  constructor(
    private toastService: ToastService,
    private themeService: ThemeService,
  ) {}

  isDarkTheme = () => this.themeService.getTheme()() === 'dark';

  showComingSoonToast() {
    this.toastService.info('Coming Soon!');
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    // Clear any pending timer to prevent race conditions
    if (this.menuTimer) clearTimeout(this.menuTimer);
    // Schedule icon animation to match the actual menu state (not toggle)
    this.menuTimer = setTimeout(() => {
      this.swapActive = this.menuOpen;
    }, 150);
  }

  closeMenu() {
    this.menuOpen = false;
    // Clear any pending timer when closing
    if (this.menuTimer) clearTimeout(this.menuTimer);
    // Reset icon immediately
    this.swapActive = false;
  }

  ngOnDestroy(): void {
    if (this.menuTimer) clearTimeout(this.menuTimer);
  }
}
